"use client";

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { Button } from '@/components/ui/button';
import { Building2, Loader2 } from 'lucide-react';

export default function LandlordPaywallButtons() {
  const [isNavigating, setIsNavigating] = useState(false);
  const [activeButton, setActiveButton] = useState<'claim' | 'learn' | null>(null);
  const router = useRouter();

  const handleNavigation = async (path: string, buttonType: 'claim' | 'learn') => {
    if (isNavigating) return;
    
    setIsNavigating(true);
    setActiveButton(buttonType);
    
    // Small delay to show loading state before navigation
    setTimeout(() => {
      router.push(path);
    }, 150);
  };

  return (
    <div className="space-y-3">
      <Button 
        onClick={() => handleNavigation('/claim', 'claim')}
        disabled={isNavigating}
        className="w-full" 
        size="lg"
      >
        {isNavigating && activeButton === 'claim' ? (
          <>
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
            Loading Claim...
          </>
        ) : (
          <>
            <Building2 className="h-4 w-4 mr-2" />
            Claim This Property
          </>
        )}
      </Button>
      
      <Button 
        variant="outline" 
        onClick={() => handleNavigation('/for-landlords', 'learn')}
        disabled={isNavigating}
        className="w-full"
      >
        {isNavigating && activeButton === 'learn' ? (
          <>
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
            Loading...
          </>
        ) : (
          'Learn More'
        )}
      </Button>
    </div>
  );
} 